export const USER_ROLES_VALUES = {
  admin: 'admin',
  user: 'user',
} as const;

export type UserRole =
  (typeof USER_ROLES_VALUES)[keyof typeof USER_ROLES_VALUES];

export const USER_ROLES_LABELS: Record<UserRole, string> = {
  admin: 'Admin',
  user: 'User',
};
